import type { ReactNode } from 'react';
import type { RouteObject } from 'react-router';

export function withLayout(layoutElement: ReactNode, children: Array<RouteObject>): RouteObject {
	return {
		element: layoutElement,
		children,
	};
}
